import { FC } from "react";
import {
  CheckCircleOutlineOutlined,
  ErrorOutlineOutlined,
} from "@mui/icons-material";
import { Button, Col, Modal, Row } from "../../../TrueUI";
import { rowWithNoMarginNorGutter } from "../../../TrueUI/Grids/Row";
import { colWithNoMarginNorGutter } from "../../../TrueUI/Grids/Col";
import styles from "./PolicyQuoteBindInstructionsStyles.module.css";

type ModalBindPolicyProps = {
  showModal: boolean;
  onClose: () => void;
  onCloseQuote: () => void;
  hasError: boolean;
  modalBody: JSX.Element;
};

const ModalBindPolicy: FC<ModalBindPolicyProps> = ({
  showModal,
  onClose,
  onCloseQuote,
  hasError,
  modalBody,
}) => {
  return (
    <Modal
      size="sm"
      id={"modal-bind-policy"}
      title={"Bind Policy"}
      open={showModal}
      showCloseButton={hasError}
      showCancelTextButton={hasError}
      saveEvent={hasError ? null : onClose}
      saveOverrideLabel="Continue"
      cancelEvent={onClose}
      sxInternalComponentsStyles={{
        ".MuiDialogContent-root": {
          pb: 0,
          pt: "16px !important",
          px: 2,
        },
      }}
      buttonRibbonNode={
        hasError ? null : (
          <Button
            variantStyle="outlined"
            onClick={onCloseQuote}
            sx={{ marginLeft: 1, marginRight: 1 }}
          >
            CLOSE QUOTE
          </Button>
        )
      }
    >
      <Row {...rowWithNoMarginNorGutter}>
        <Col
          {...colWithNoMarginNorGutter}
          breakpoints={{ md: 2, lg: 2, xl: 2 }}
        >
          {hasError ? (
            <ErrorOutlineOutlined
              className={styles.modal_bind_policy_button_with_error}
            />
          ) : (
            <CheckCircleOutlineOutlined
              className={styles.modal_bind_policy_button}
            />
          )}
        </Col>
        <Col
          horizontalAlign="flex-start"
          breakpoints={{ md: 10, lg: 10, xl: 10 }}
        >
          {modalBody}
        </Col>
      </Row>
    </Modal>
  );
};

export default ModalBindPolicy;
